<script type="text/javascript">
	import Button from '@smui/button';
	import DataTable,{ Body,Cell,Head,Row } from '@smui/data-table';
	import IconButton from "@smui/icon-button";
	import Select,{ Option } from '@smui/select';
	import Tab,{ Label } from '@smui/tab';
	import TabBar from '@smui/tab-bar';
	import Sortable from "sortablejs/modular/sortable.core.esm.js";
	import { afterUpdate,beforeUpdate,tick } from "svelte";
	import { get,writable } from "svelte/store";
	import API from "../../API/API";
	import AuthStore from "../../Auth/Store";
	import Feature from "../../Branding/Feature";
	import UserHelper from "../../Branding/User";
	import LoadState from "../../Enums/LoadState";
	import UIHelper from "../../Helpers/UIHelper";
	import Company from "../../Models/Company";
	import Image from "../../Models/Image";
	import ImageCollection from "../../Models/ImageCollection";
	import ROI from "../../Models/ROI";
	import Tier from "../../Models/Tier";
	import User from "../../Models/User";
	import ConfirmDialogView from "../ConfirmDialog/ConfirmDialogView.svelte";
	import MenuItemTitle from "../FlyoutMenu/MenuItemTitle.svelte";
	import ModalWindow from "../ModalWindow.svelte";
	import NavPathItem from '../NavPath/Item.svelte';
	import NavPath from '../NavPath/NavPath.svelte';
	import Spinner from "../Spinner/Spinner.svelte";
	import SpinnerSize from "../Spinner/SpinnerSize";
	import VesselCommentsCMSView from '../VesselComments/CMSView.svelte';
	import "./CMS.scss";
	import CMSSpinner from "./CMSSpinner.svelte";
	import CompanyForm from "./CompanyForm.svelte";
	import ImageCollectionForm from "./ImageCollectionForm.svelte";
	import ImageForm from "./ImageForm.svelte";
	import ROIForm from "./ROIForm.svelte";
	import AdminStore from "./Store";
	import TierForm from "./TierForm.svelte";
	import UserForm from "./UserForm.svelte";
			
	

	let loadState = AdminStore.cms.meta.loadState;
	let users = AdminStore.cms.users;
	let companies = AdminStore.cms.companies;
	let tiers = AdminStore.cms.tiers;
	let rois = AdminStore.cms.rois;
	let images = AdminStore.cms.images;
	let imageCollections = AdminStore.cms.imageCollections;
	let vesselCommentThreads = AdminStore.cms.vesselCommentThreads;
	let vesselCommentThreadDetails = AdminStore.cms.vesselCommentThreadDetails;
	let allAlertTypes = AdminStore.cms.alertTypes;
	let unattributedUsers = AdminStore.cms.unattributedUsers;
	let open = AdminStore.cms.visible;

	let viewSingleVesselCommentThread = writable(null);

	let tabs = [];
	let activeTab = writable("");

	let createOrUpdateTabs = (setActiveTab = false) => {
		let thisTabs = [];
		if (UserHelper.hasFeature(Feature.ADMIN.EDIT) || UserHelper.hasFeature(Feature.ADMIN.USERS.VIEW)) {
			thisTabs.push("Users");
		}
		if (UserHelper.hasFeature(Feature.ADMIN.EDIT) || UserHelper.hasFeature(Feature.ADMIN.COMPANIES.VIEW)) {
			thisTabs.push("Companies");
		}
		if (UserHelper.hasFeature(Feature.ADMIN.EDIT) || UserHelper.hasFeature(Feature.ADMIN.TIERS.VIEW)) {
			thisTabs.push("Tiers");
		}
		if (UserHelper.hasFeature(Feature.ADMIN.EDIT) || UserHelper.hasFeature(Feature.ADMIN.ROIS.VIEW)) {
			thisTabs.push("ROIs");
		}
		if (UserHelper.hasFeature(Feature.ADMIN.EDIT)) {
			thisTabs.push("Alert Types");
		}
		if (UserHelper.hasFeature(Feature.ADMIN.EDIT) || UserHelper.hasFeature(Feature.ADMIN.IMAGES.VIEW)) {
			thisTabs.push("Images");
		}
		if (UserHelper.hasFeature(Feature.ADMIN.EDIT) || UserHelper.hasFeature(Feature.ADMIN.COMMENTS.VIEW)) {
			thisTabs.push("Vessel Comments");
		}

		if (UserHelper.hasFeature(Feature.ADMIN.EDIT) || 
			UserHelper.hasFeature(Feature.ADMIN.USERS.VIEW) || 
			UserHelper.hasFeature(Feature.ADMIN.COMPANIES.VIEW)) 
			{
			thisTabs.push("Tools");
		}

		if (setActiveTab) {
			$activeTab = thisTabs[0];
		}
		tabs = thisTabs;
	};

	$: {
		createOrUpdateTabs($open);
	}
	beforeUpdate(()=>{
		createOrUpdateTabs(false);
	});


	$: {
		if ($open) {
			AdminStore.actions.refresh();
		} else {
			clearEditing();
		}
	};
	$: {
		$activeTab;
		clearEditing();
	}

	// let snackbar;
	let modal;
	let editingUser = writable(null);
	let editingCompany = writable(null);
	let editingTier = writable(null);
	let editingRoi = writable(null);
	let editingImage = writable(null);
	let editingImageCollection = writable(null);
	let setEditingUser = (obj) => { $editingUser = obj; if (modal) modal.scrollToTop() }
	let setEditingCompany = (obj) => { $editingCompany = obj; if (modal) modal.scrollToTop() }
	let setEditingTier = (obj) => { $editingTier = obj; if (modal) modal.scrollToTop() }
	let setEditingROI = (obj) => { $editingRoi = obj; if (modal) modal.scrollToTop() }
	let setEditingImage = (obj) => { $editingImage = obj; if (modal) modal.scrollToTop() }
	let setEditingImageCollection = (obj) => { $editingImageCollection = obj; if (modal) modal.scrollToTop() }
	let clearEditing = () => {
		$editingUser = null;
		$editingCompany = null;
		$editingTier = null;
		$editingRoi = null;
		$editingImage = null;
		$editingImageCollection = null;
		if (modal) modal.scrollToTop();
	}

	let formatLimit = (limit) => {
		return ((limit == -1)?"Unlimited":limit);
	}
	let formatUserCount = (count, limit) => {
		return count + " / " + formatLimit(limit)
	};

	let importUnattributedUser = (unattributedUser) => {
		let buttonElement = document.getElementById("import-unattributed-button-"+unattributedUser.cognito_id);
		UIHelper.setReadOnly(buttonElement, true);
		if (unattributedUser.company_name == "") {
			//snackbar.start("Please set a company.", "error");
			UIHelper.setReadOnly(buttonElement, false);
			return;
		}
		let company = AdminStore.helpers.getCompanyByName(unattributedUser.company_name);
		if (company === null) {
			//snackbar.start("Invalid company.", "error");
			UIHelper.setReadOnly(buttonElement, false);
			return;
		}


		let data = {
			username: unattributedUser.username,
			cognito_id: unattributedUser.cognito_id,
			company_id: company.id
		};

		API.put("admin/users/import", data)
			.then((response)=>{
				UIHelper.setReadOnly(buttonElement, false);
				AdminStore.actions.addUser(new User(response));
				AdminStore.actions.deleteUnattributedUser(unattributedUser);
				//snackbar.start("User imported successfully.", "success");
			})
			.catch(() => {
				UIHelper.setReadOnly(buttonElement, false);
				//snackbar.start("Unattributed User import failed.", "error");
			});
	}


	// Identity change
	$: identities = $companies.map((company) => { return company.name; })
	$: clientIdentity = get(AuthStore.userInfo).identity;
	let onIdentityChange = (e) => {
		const newCompany = e.target.value;

		// get company from name, get tier (0) from company, then get feature list from tier.
		const company = AdminStore.helpers.getCompanyByName(newCompany);
		const tier = AdminStore.helpers.getTierById(company.tierId);
		const features = Feature.processKeyedFeaturesIntoArray(tier.features);

		let pairs = company.get("alert_type_roi_pairs");
		let roiIds = [];
		let alertTypeCodes = [];
		for(let i = 0; i < pairs.length; i++) {
			if (roiIds.indexOf(pairs[i].roi_id) == -1) {
				roiIds.push(pairs[i].roi_id);
			}
			if (alertTypeCodes.indexOf(pairs[i].alert_type_code) == -1) {
				alertTypeCodes.push(pairs[i].alert_type_code);
			}
		}

		let rois = roiIds.map((id) => {
			return AdminStore.helpers.getROIById(id);
		});
		let alertTypes = alertTypeCodes.map((code) => {
			for(let i = 0; i < get(AuthStore.session.alertTypes).length; i++) {
				if (code === get(AuthStore.session.alertTypes)[i].code) {
					return get(AuthStore.session.alertTypes)[i];
				}
			}
			console.warn("invalid alert type.");
			return {};
		});

		AuthStore.session.rois.set(rois);
		AuthStore.session.alertTypes.set(alertTypes);

		AuthStore.userInfo.update((userInfo) => {
			return {
				...userInfo,
				identity: newCompany.toLowerCase(), // TODO: proper theming rather than company/identity based.
				forceIdentity: newCompany.toLowerCase(),
				forceIdentityId: company.id,
				features: [
					...features,
					Feature.ADMIN.VIEW,
					Feature.ADMIN.EDIT
				]

			};
		});
		AuthStore.actions.save();
		window.location = window.location;
	}

	let useraddcontextmenu;

	// Alert Types
	let sortableAlertsLoadState = writable(LoadState.INIT);
	let sortableAlerts = null;
	let sortableAlertsIndex = 0;
	let sortableAlertsListElement = null;
	let sortableAlertsPrevState = null;
	let trySaveAlertsOrder = () => {
		$sortableAlertsLoadState = LoadState.LOADING;
		const prevState = JSON.parse(JSON.stringify($allAlertTypes));
		tick().then(()=>{

			API.put("admin/alert-types", { codes: sortableAlerts.toArray() })
				.then((response)=>{
					$allAlertTypes = response;
				})
				.catch((err) => {
					$allAlertTypes = [];
					console.error(err);
					tick().then(()=>{
						$allAlertTypes = prevState;
					});
				})
				.finally(() => {
					sortableAlertsIndex++;
					$sortableAlertsLoadState = LoadState.INIT;
				});
		});
	};

	$: {
		$sortableAlertsLoadState;
		if ($activeTab === "Alert Types") {
			afterUpdate(() => {
				if (sortableAlertsListElement !== null) {
					sortableAlerts = new Sortable(sortableAlertsListElement, {
						group: "alert-types-" + sortableAlertsIndex,
						sort: true,
						draggable: ".mdc-list-item",
						handle: ".handle",
						onEnd: (evt) => {
							// evt.oldIndex, evt.newIndex
							trySaveAlertsOrder();
						}
					});
				}
			});
		}
		// TODO: destroying it seems to cause a infinite loop/crash. I guess it's fine. ^AG
		// else {
		// 	if (sortableAlerts !== null) {
		// 		sortableAlerts.destroy();
		// 		sortableAlerts = null;
		// 	}
		// }
	}
	$: {
		$allAlertTypes;
	}

	let imagesShowCompanyImages = false;


</script>

<ModalWindow
	materialIcon={"supervisor_account"}
	title={`CMS`}
	hasCloseButton={true}
	resizable={false}
	draggable={false}
	fullscreen={true}
	padding={false}
	bind:open={$open}
	bind:this={modal} >

	<!-- <FormSnackbar bind:this={snackbar}/> -->

	{#if $loadState == LoadState.LOADING}
		<CMSSpinner/>
	{:else if $loadState == LoadState.LOADED}

		<TabBar tabs={tabs} let:tab bind:active={$activeTab} class="border-shadow">
			<Tab {tab} minWidth><Label>{tab}</Label></Tab>
		</TabBar>

		<div class='tab-content'>
			{#if $activeTab == "Users"}
				{#if $editingUser === null}
					<MenuItemTitle title={"Users"} materialIcon={"account_circle"}>
						<slot name='context-menu'>
							<IconButton class="material-icons" on:click={()=>{ setEditingUser(new User({})); }}>add</IconButton>
						</slot>
					</MenuItemTitle>

					<DataTable table$aria-label="Users">
						<Head>
							<Row>
								<Cell>Username</Cell>
								<Cell>Email</Cell>
								<Cell>Status</Cell>
								<Cell>Company</Cell>
							</Row>
						</Head>
						<Body>
							{#each $users as user}
								<Row>
									<Cell><a href="/" on:click={(e)=>{ e.preventDefault(); setEditingUser(user); }}>{user.username}</a></Cell>
									<Cell>{user.email}</Cell>
									<Cell>{user.status}</Cell>
									<Cell>{user.companyName}</Cell>
								</Row>
							{/each}
						</Body>
					</DataTable>
					<br/>

					{#if $unattributedUsers.length > 0}

						<MenuItemTitle title={"Unattributed Users"} materialIcon={"account_circle"}/>
						<DataTable table$aria-label="Users">
							<Head>
								<Row>
									<Cell>Username</Cell>
									<Cell>Email</Cell>
									<Cell>Company</Cell>
									<Cell></Cell>
								</Row>
							</Head>
							<Body>
								{#each $unattributedUsers as user}
									<Row>
										<Cell><a href="/" on:click={(e)=>{ e.preventDefault(); setEditingUser(user); }}>{user.username}</a></Cell>
										<Cell>{user.email}</Cell>
										<Cell>
											<select class='default' bind:value={user.company_name}>
												<option value="" selected="true"></option>
												{#each $companies as company}
													<option value={company.name} selected={user.company_name === company.name}>{company.name}</option>
												{/each}
											</select>
										</Cell>
										<Cell>
											<Button id={"import-unattributed-button-"+user.cognito_id} on:click={()=>{
												importUnattributedUser(user);
											}} color="secondary" class="bg-info" variant="unelevated" data->
												<Label>Import</Label>
											</Button>
										</Cell>
									</Row>
								{/each}
							</Body>
						</DataTable>
						<p>These are users that have been mistakenly created through the AWS dashboard - they need importing &amp; assigning to a company.</p>

					{/if}

				{:else}
					<NavPath>
						<NavPathItem materialIcon={"account_circle"}></NavPathItem>
						<NavPathItem link on:click={clearEditing}>Users</NavPathItem>
						<NavPathItem spacer/>
						<NavPathItem>{($editingUser.isNew()?"New":$editingUser.username)}</NavPathItem>
					</NavPath>
					<UserForm
						user={$editingUser}
						on:submit={(e)=>{ $editingUser = e.detail.user; }}
						on:delete={()=>{ clearEditing() }}
						/>
				{/if}
			{:else if $activeTab == "Companies"}
				{#if $editingCompany === null}
					<MenuItemTitle title={"Companies"} materialIcon={"business"}>
						<slot name='context-menu'>
							<IconButton class="material-icons" on:click={()=>{ setEditingCompany(new Company({})); }}>add</IconButton>
						</slot>
					</MenuItemTitle>
					<DataTable table$aria-label="Companies">
						<Head>
							<Row>
								<Cell>Name</Cell>
								<Cell>IMOs</Cell>
								<Cell>Tier</Cell>
								<Cell>Users</Cell>
							</Row>
						</Head>
						<Body>
							{#each $companies as company}
								<Row>
									<Cell><a href="/" on:click={(e)=>{ e.preventDefault(); setEditingCompany(company); }}>{company.name}</a></Cell>
									<Cell>{company.imos}</Cell>
									<Cell>{company.tierName}</Cell>
									<Cell>{formatUserCount(company.userCount, company.tierUserLimit)}</Cell>
								</Row>
							{/each}
						</Body>
					</DataTable>
				{:else}
					<NavPath>
						<NavPathItem materialIcon={"business"}></NavPathItem>
						<NavPathItem link on:click={clearEditing}>Companies</NavPathItem>
						<NavPathItem spacer/>
						<NavPathItem>{($editingCompany.isNew()?"New":$editingCompany.name)}</NavPathItem>
					</NavPath>
					<CompanyForm
						company={$editingCompany}
						on:submit={(e)=>{ $editingCompany = e.detail.company; }}
						on:delete={()=>{ clearEditing() }}
						/>
				{/if}
			{:else if $activeTab == "Tiers"}
				{#if $editingTier === null}
					<MenuItemTitle title={"Tiers"} materialIcon={"account_balance"}>
						<slot name='context-menu'>
							<IconButton class="material-icons" on:click={()=>{ setEditingTier(new Tier({})); }}>add</IconButton>
						</slot>
					</MenuItemTitle>
					<DataTable table$aria-label="Tiers">
						<Head>
							<Row>
								<Cell>Name</Cell>
								<!-- <Cell>Features</Cell> -->
								<Cell>User Limit</Cell>
								<Cell>Alert Type Limit</Cell>
								<Cell>ROI (Per Alert Type) Limit</Cell>
							</Row>
						</Head>
						<Body>
							{#each $tiers as tier}
								<Row>
									<Cell><a href="/" on:click={(e)=>{ e.preventDefault(); setEditingTier(tier); }}>{tier.name}</a></Cell>
									<!-- <Cell>{tier.features}</Cell> -->
									<Cell>{formatLimit(tier.userLimit)}</Cell>
									<Cell>{formatLimit(tier.alertTypeLimit)}</Cell>
									<Cell>{formatLimit(tier.roiPerAlertTypeLimit)}</Cell>
								</Row>
							{/each}
						</Body>
					</DataTable>
				{:else}
					<NavPath>
						<NavPathItem materialIcon={"account_balance"}></NavPathItem>
						<NavPathItem link on:click={clearEditing}>Tiers</NavPathItem>
						<NavPathItem spacer/>
						<NavPathItem>{($editingTier.isNew()?"New":$editingTier.name)}</NavPathItem>
					</NavPath>
					<TierForm
						tier={$editingTier}
						on:submit={(e)=>{ $editingTier = e.detail.tier; }}
						on:delete={()=>{ clearEditing() }}
						/>
				{/if}
			{:else if $activeTab == "ROIs"}
				{#if $editingRoi === null}
					<MenuItemTitle title={"ROIs"} materialIcon={"place"}>
						<slot name='context-menu'>
							<IconButton class="material-icons" on:click={()=>{ setEditingROI(new ROI({})); }}>add</IconButton>
						</slot>
					</MenuItemTitle>
					<DataTable table$aria-label="ROIs">
						<Head>
							<Row>
								<Cell>Name</Cell>
								<Cell>Type</Cell>
							</Row>
						</Head>
						<Body>
							{#each $rois as roi}
								<Row>
									<Cell><a href="/" on:click={(e)=>{ e.preventDefault(); setEditingROI(roi); }}>{roi.name}</a></Cell>
									<Cell>{roi.regionType}</Cell>
								</Row>
							{/each}
						</Body>
					</DataTable>
				{:else}
					<NavPath>
						<NavPathItem materialIcon={"place"}></NavPathItem>
						<NavPathItem link on:click={clearEditing}>ROIs</NavPathItem>
						<NavPathItem spacer/>
						<NavPathItem>{($editingRoi.isNew()?"New":$editingRoi.name)}</NavPathItem>
					</NavPath>
					<ROIForm
						roi={$editingRoi}
						on:submit={(e)=>{ $editingRoi = e.detail.roi; }}
						on:delete={()=>{ clearEditing() }}
						/>
				{/if}

			{:else if $activeTab == "Alert Types"}

				<MenuItemTitle title={"Alert Types"} materialIcon={"notification_important"}/>
				<p>Drag to re-order. Alerts at the top of the list render at the top of the map.</p>

				<ul class='striped-list mdc-list mdc-list--non-interactive' bind:this={sortableAlertsListElement} role="list">
					{#each $allAlertTypes as row (row.id)}
						<li class={"mdc-list-item " + (($sortableAlertsLoadState === LoadState.INIT)?"draggable":"")} data-id={row.code} style="padding:5px;">
							{#if $sortableAlertsLoadState === LoadState.INIT}
								<IconButton style="cursor:move;" class="material-icons handle">drag_indicator</IconButton>
							{:else}
								<div style='margin-left:15px;margin-top:15px;width:33px;height:33px;'>
									<Spinner size={SpinnerSize.MINI} absolute={false} inline={true} />
								</div>
							{/if}
							&nbsp;<span class="shortcode">{row.code}</span>&nbsp;{row.name}
						</li>
					{/each}
				</ul>

			{:else if $activeTab == "Images"}

				<p>Images are uploaded individually and grouped into collections. Access is given to companies on a per-collection basis.</p>

				{#if $editingImage === null && $editingImageCollection === null}

					<button class='btn btn-sml bg-primary btn-primary' on:click={()=>{
						imagesShowCompanyImages = !imagesShowCompanyImages;
					}}>{#if !imagesShowCompanyImages}Show{:else}Hide{/if} Company Images</button>

					<MenuItemTitle title={"Image Collections"} materialIcon={"collections"}>
						<slot name='context-menu'>
							<IconButton class="material-icons" on:click={()=>{ setEditingImageCollection(new ImageCollection({})); }}>add</IconButton>
						</slot>
					</MenuItemTitle>
					<DataTable table$aria-label="Image Collections">
						<Head>
							<Row>
								<Cell>Name</Cell>
								<Cell>Category</Cell>
								<Cell>Number of Images</Cell>
								<Cell>Visibility</Cell>
							</Row>
						</Head>
						<Body>
							{#each $imageCollections as imageCollection}
								{#if imageCollection.ownerCompanyId === 0 || (imagesShowCompanyImages)}
									<Row>
										<Cell>
											<a href="/" on:click={(e)=>{ e.preventDefault(); setEditingImageCollection(imageCollection); }}>{imageCollection.name}</a>
											{#if imageCollection.ownerCompanyId !== 0}
												(owned by {imageCollection.ownerCompanyName})
											{/if}
										</Cell>
										<Cell>{imageCollection.category}</Cell>
										<Cell>{imageCollection.imageCount}</Cell>
										<Cell>{imageCollection.visibility}</Cell>
									</Row>
								{/if}
							{/each}
							{#if $imageCollections.length === 0}
								<Row>
									<Cell colspan='4'>No Image Collections</Cell>
								</Row>
							{/if}
						</Body>
					</DataTable>


					<MenuItemTitle title={"Images"} materialIcon={"insert_photo"}>
						<slot name='context-menu'>
							<IconButton class="material-icons" on:click={()=>{ setEditingImage(new Image({})); }}>add</IconButton>
						</slot>
					</MenuItemTitle>

					<DataTable table$aria-label="Images">
						<Head>
							<Row>
								<Cell>Name</Cell>
								<Cell>File</Cell>
								<Cell>Type</Cell>
								<Cell>Size</Cell>
							</Row>
						</Head>
						<Body>
							{#each $images as image}
								{#if image.ownerUserId === 0 || (imagesShowCompanyImages)}
									<Row>
										<Cell>
											<a href="/" on:click={(e)=>{ e.preventDefault(); setEditingImage(image); }}>{image.name}</a>
											{#if image.ownerUserId !== 0}
												(uploaded by {image.ownerUserName})
											{/if}
										</Cell>
										<Cell>{image.fileName}</Cell>
										<Cell>{image.fileType}</Cell>
										<Cell>{image.readableSize}</Cell>
									</Row>
								{/if}
							{/each}
							{#if $images.length === 0}
								<Row>
									<Cell colspan='4'>No Image Assets</Cell>
								</Row>
							{/if}
						</Body>
					</DataTable>


				{:else if $editingImage !== null}
					<NavPath>
						<NavPathItem materialIcon={"insert_photo"}></NavPathItem>
						<NavPathItem link on:click={clearEditing}>Images</NavPathItem>
						<NavPathItem spacer/>
						<NavPathItem>{($editingImage.isNew()?"New":$editingImage.name)}</NavPathItem>
					</NavPath>
					<ImageForm
						image={$editingImage}
						confirmDialog={AdminStore.cms.confirmDialog}
						on:added={(e)=>{
							AdminStore.actions.addImage(e.detail.image);
						}}
						on:submit={(e)=>{
							if (e.detail.returnToMenu) {
								clearEditing();
								return;
							}
							$editingImage = e.detail.image;
						}}
						on:delete={(e)=>{
							AdminStore.actions.deleteImage(e.detail.image);
							clearEditing()
						}}
						/>
				{:else if $editingImageCollection !== null}
					<NavPath>
						<NavPathItem materialIcon={"collections"}></NavPathItem>
						<NavPathItem link on:click={clearEditing}>Image Collections</NavPathItem>
						<NavPathItem spacer/>
						<NavPathItem>{($editingImageCollection.isNew()?"New":$editingImageCollection.name)}</NavPathItem>
					</NavPath>
					<ImageCollectionForm
						imageCollection={$editingImageCollection}
						on:submit={(e)=>{ $editingImageCollection = e.detail.imageCollection; }}
						on:delete={()=>{ clearEditing() }}
						/>
				{/if}

			{:else if $activeTab == "Vessel Comments"}

				<VesselCommentsCMSView threads={vesselCommentThreads} threadsDetails={vesselCommentThreadDetails} confirmDialog={AdminStore.cms.confirmDialog} />
				
			{:else if $activeTab == "Tools"}
				<MenuItemTitle title={"Tools"} materialIcon={"build"}></MenuItemTitle>

				<div style="padding:5%;border:1px solid #ccc;padding-top:3px;border-radius:3px;">
					<h1><span class='material-icons header-icon'>account_circle</span>View As</h1>
					<Select bind:value={clientIdentity} label="Client" on:change={onIdentityChange} style="width:100%;">
						<Option value=""></Option>
						{#each identities as ident}
							<Option value={ident} selected={clientIdentity === ident}>{ident}</Option>
						{/each}
					</Select>
			    </div>
			{/if}
		</div>
	{/if}

</ModalWindow>

<ConfirmDialogView data={AdminStore.cms.confirmDialog} />

